module.exports = __webpack_public_path__ + "static/media/imgLoading.dd32a776.svg";